import { createContext as e } from "react";
const n = e({
  getItemProps: () => ({}),
  activeIndex: null,
  setActiveIndex: () => {
  },
  setHasFocusInside: () => {
  },
  isOpen: !1
});
export {
  n as MenuContext
};
